import React from 'react';
import { injectIntl, FormattedNumber, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import IntlDateTime from 'components/layout/IntlDateTime';

class OrderPaymentInfos extends React.Component {
  getName = methodType => {
    const {
      intl: { messages },
    } = this.props;

    switch (methodType) {
      case 'creditCard':
        return messages.payment_creditCard;

      case 'payPal':
        return messages.payment_payPal;

      case 'cash':
        return messages.payment_cash;

      case 'escrow':
        return messages.payment_escrow;

      case 'carCredit':
        return messages.payment_car_credit;

      case 'wireTransfer':
        return messages.payment_wire_transfer;
    }

    return '?';
  };

  getDetails = (methodType, detailsType = null) => {
    const {
      intl: { messages },
      entity,
    } = this.props;

    const paymentInfo = entity.getPaymentInfo();
    const res = [];

    switch (methodType) {
      case 'creditCard':
        res.push(
          <React.Fragment key="paymentDetails">
            <dt />
            <dd>
              <dl class="no-margin sm-p-l-20">
                <dt>{messages.credit_card_holder}</dt>
                <dd>{paymentInfo.getStripePayment().getCreditCardHolder()}</dd>

                <dt class="m-t-5">{messages.credit_card_number}</dt>
                <dd>
                  <span class="hint-text">**** **** ****</span> {paymentInfo.getStripePayment().getCreditCardLast4()}
                </dd>

                <dt class="m-t-5">{messages.amount}</dt>
                <dd>
                  <FormattedNumber
                    value={paymentInfo.getAmount()}
                    style="currency"
                    currency={paymentInfo.getCurrency()}
                  />
                </dd>

                {!!paymentInfo.getRefunds().length && (
                  <div>
                    <dt class="m-t-5">{messages.refunds}</dt>
                    <dd>{paymentInfo.getRefunds().length}</dd>
                  </div>
                )}
              </dl>
            </dd>
          </React.Fragment>
        );
        break;

      case 'cash':
        if (detailsType === null) {
          res.push(
            <React.Fragment key="paymentDetails">
              <dt class="m-t-5" />
              <dd>
                <dl class="no-margin sm-p-l-20">
                  <dt>{messages.amount}</dt>
                  <dd>
                    <FormattedNumber
                      value={entity.getCarCashPayment().getAmount()}
                      style="currency"
                      currency={entity.getCurrency()}
                    />
                  </dd>
                </dl>
              </dd>
            </React.Fragment>
          );
        } else if (detailsType === 'car') {
          res.push(
            <React.Fragment key="paymentDetails">
              <dt class="m-t-5" />
              <dd key="paymentDetailsDd">
                <dl class="no-margin sm-p-l-20">
                  <dt>{messages.amount}</dt>
                  <dd>
                    <FormattedNumber
                      value={entity.getCarCashPayment().getAmount()}
                      style="currency"
                      currency={entity.getCurrency()}
                    />
                  </dd>
                </dl>
              </dd>
            </React.Fragment>
          );
        }
        break;

      case 'carCredit':
        res.push(
          <React.Fragment>
            <dt class="m-t-5" />
            <dd key="paymentDetailsDd">
              <dl class="no-margin sm-p-l-20">
                <dt>{messages.amount}</dt>
                <dd>
                  <FormattedNumber
                    value={entity.getCarCreditPayment().getAmount()}
                    style="currency"
                    currency={entity.getCurrency()}
                  />
                </dd>
              </dl>
            </dd>
          </React.Fragment>
        );
        break;

      case 'escrow':
        res.push(
          <React.Fragment key="paymentDetails">
            <dt class="m-t-5" />
            <dd>
              <dl class="no-margin sm-p-l-20">
                <dt>{messages.amount}</dt>
                <dd>
                  <FormattedNumber
                    value={entity.getCarEscrowPayment().getAmount()}
                    style="currency"
                    currency={entity.getCurrency()}
                  />
                </dd>
              </dl>
            </dd>
          </React.Fragment>
        );
        break;

      case 'wireTransfer':
        res.push(
          <React.Fragment key="paymentDetails">
            <dt class="m-t-5" />
            <dd>
              <dl class="no-margin sm-p-l-20">
                <dt>{messages.amount}</dt>
                <dd>
                  <FormattedNumber
                    value={entity.getCarWireTransferPayment().getAmount()}
                    style="currency"
                    currency={entity.getCurrency()}
                  />
                </dd>
                <dt class="m-t-5">{messages.status}</dt>
                <dd>{messages.paymentStatus[entity.getCarWireTransferPayment().getStatus()]}</dd>
                <dt class="m-t-5">{messages.payment_instructions}</dt>
                <dd>
                  {entity.getCarWireTransferPayment().getPaymentInstructionsSent() ? (
                    <FormattedMessage
                      id="sent_on_date"
                      values={{
                        date: <IntlDateTime date={entity.getCarWireTransferPayment().getPaymentInstructionsSentOn()} />,
                      }}
                    />
                  ) : (
                    messages.not_sent_yet
                  )}

                  {entity.getCarWireTransferPayment().getPaymentInstructionsSent() && (
                    <span>
                      <br />
                      {entity.getCarWireTransferPayment().getPaymentInstructions()}
                    </span>
                  )}
                </dd>

                {entity.getCarWireTransferPayment().getPaymentInstructionsSent() && (
                  <div class="m-t-15">
                    <dt>{messages.iban}</dt>
                    <dd>
                      {entity
                        .getCarWireTransferPayment()
                        .getBankData()
                        .getIban()}
                    </dd>
                    <dt class="m-t-5">{messages.swift_bic}</dt>
                    <dd>
                      {entity
                        .getCarWireTransferPayment()
                        .getBankData()
                        .getSwiftBic()}
                    </dd>
                    <dt class="m-t-5">{messages.payment_reference}</dt>
                    <dd>{entity.getCarWireTransferPayment().getReference()}</dd>
                  </div>
                )}
              </dl>
            </dd>
          </React.Fragment>
        );
        break;
    }

    return res;
  };

  render() {
    const {
      intl: { messages },
      entity,
    } = this.props;

    const type = entity.getType();

    return (
      <dl class="no-margin">
        <dt>{type === 'car_sales' ? messages.first_payment : messages.payment_method}</dt>
        <dd>{this.getName(entity.getPayment())}</dd>

        {this.getDetails(entity.getPayment())}

        {type === 'car_sales' && (
          <React.Fragment>
            <dt class="m-t-15">{messages.second_payment}</dt>
            <dd>{this.getName(entity.getCarPayment())}</dd>
            {this.getDetails(entity.getCarPayment(), 'car')}
          </React.Fragment>
        )}
      </dl>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(OrderPaymentInfos));
